<template>
  <div>
    <b-card class="mb-1">
      <template #header>
        <b-row class="flex-row justify-content-between align-items-center" style="width:100%">
          <b-col>
            <h4 class="mb-0">Client Onboarding</h4>
          </b-col>
          <b-col cols="auto">
            <b-form-input
              v-model="filter"
              placeholder="Search account name or number…"
              style="min-width:280px"
            />
          </b-col>
        </b-row>
      </template>

      <b-table
        :items="accounts"
        :fields="fields"
        :filter="filter"
        :busy="loading"
        hover
        responsive
        show-empty
        empty-text="No accounts found."
        @row-clicked="openDetail"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-1" />
            <strong>Loading…</strong>
          </div>
        </template>

        <template #cell(OnboardingStatus)="{ value }">
          <b-badge :variant="statusVariant(value)">{{ value }}</b-badge>
        </template>

        <template #cell(actions)="{ item }">
          <b-button
            variant="flat-primary"
            size="sm"
            @click.stop="openDetail(item)"
          >
            <feather-icon icon="EyeIcon" size="14" class="mr-25" />
            Open
          </b-button>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import store from "@/store";
import onboardingStoreModule from "./onboardingStoreModule";

const STORE_MODULE = "onboarding";

export default {
  name: "OnboardingList",

  data() {
    return {
      accounts: [],
      loading: false,
      filter: "",
      fields: [
        { key: "AccountName", label: "Account Name", sortable: true },
        { key: "AccountNumber", label: "Account Number", sortable: true },
        { key: "ContactEmail", label: "Contact Email" },
        { key: "OnboardingStatus", label: "Onboarding Status", sortable: true },
        { key: "SignedDate", label: "Signed Date", sortable: true },
        { key: "actions", label: "" },
      ],
    };
  },

  beforeCreate() {
    if (!store.hasModule(STORE_MODULE)) {
      store.registerModule(STORE_MODULE, onboardingStoreModule);
    }
  },

  mounted() {
    this.loadList();
  },

  destroyed() {
    if (store.hasModule(STORE_MODULE)) {
      store.unregisterModule(STORE_MODULE);
    }
  },

  methods: {
    loadList() {
      this.loading = true;
      store
        .dispatch(`${STORE_MODULE}/getOnboardingList`)
        .then((res) => {
          this.accounts = res.data || [];
        })
        .catch((err) => {
          console.error(err);
          this.$bvToast.toast("Failed to load accounts.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openDetail(item) {
      this.$router.push({ name: "onboarding-detail", params: { id: item.id } });
    },

    statusVariant(status) {
      switch (status) {
        case "Signed":
          return "success";
        case "InProgress":
          return "warning";
        case "Draft":
          return "info";
        default:
          return "secondary";
      }
    },
  },
};
</script>
